module.exports = __webpack_public_path__ + "media/theme/step-arrow-33cec598.png";